<template>
	<div
		class="form-input"
		:class="{
			'form-input--icon': icon,
			'form-input--disabled': disabled,
			'form-input--focused': focused,
			'form-input--error': error,
			'form-input--success': success,
			'form-input--not-empty': value != '' && value !== undefined,
		}"
	>
		<div class="form-input__wrapper">
			<input
				ref="input"
				:type="type"
				:id="id"
				:name="name"
				class="form-input__field"
				:class="{
					'form-input__field--valid': !error,
					'form-input__field--invalid': error,
					'form-input__field--empty': value == '',
					'form-input__field--password': type == 'password',
				}"
				:placeholder="placeholder"
				:required="required"
				:disabled="disabled"
				:readonly="readonly"
				:minlength="minlength"
				:maxlength="maxlength"
				:inputmode="inputmode"
				:pattern="pattern"
				:value="value"
				@input="onInput"
				@focus="onFocus"
				@blur="onBlur"
				@keyup="onKeyup"
				@keydown="onKeydown"
			/>
			<label
				:for="id"
				class="form-input__label | form-input-label"
				v-if="label"
			>
				<span
					class="form-input-label__text"
					v-html="label"
				/>
				<span
					class="form-input-label__option"
					v-if="labelOption"
					v-html="labelOption"
				/>
			</label>
			<component
				class="form-input__icon"
				v-if="icon"
				:is="iconComponent(icon)"
			/>
		</div>
		<span
			class="form-input__hint | form-input-hint"
			v-if="hint"
			v-html="hint"
		/>
		<span
			class="form-input__error | form-input-error"
			v-if="error && errorMessage"
			v-html="errorMessage"
		/>
		<span
			class="form-input__success | form-input-success"
			v-if="successMessage"
			v-html="successMessage"
		/>
	</div>
</template>

<script>
export default {
	props: {
		id: String,
		name: String,
		value: Number | String,
		type: {
			type: String,
			default() {
				return 'text';
			},
		},
		placeholder: String,
		required: Boolean,
		disabled: Boolean,
		readonly: Boolean,
		maxlength: Number,
		minlength: Number,
		inputmode: String,
		pattern: String,
		label: String,
		labelOption: String,
		icon: String,
		hint: String,
		error: Boolean,
		errorMessage: String,
		success: Boolean,
		successMessage: String,
	},
	data() {
		return {
			focused: false,
		}
	},
	computed: {
	},
	model: {
		prop: 'value',
		event: 'input'
	},
	methods: {
		focus() {
			this.$refs.input.focus();
		},
		onInput(e) {
			this.$emit('input', e.target.value);
		},
		onFocus(e) {
			this.focused = true;
			this.$emit('focus', e);
		},
		onBlur(e) {
			this.focused = false;
			this.$emit('blur', e);
		},
		onKeyup(e) {
			this.$emit('keyup', e);
		},
		onKeydown(e) {
			this.$emit('keydown', e);
		},
	},
}
</script>

<style>

</style>
